import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 查询帐单列表
 * @param {Object} data
 * @returns
 */
export function pageElectricBill (data) {
  return request.post('/ooh-invest/electricMeterBill/pageElectricBill', qs.stringify(data))
}
/**
 * 新增收款账单
 * @param {Object} data
 * @returns
 */
export function addElectricBill (data) {
  return request.post('/ooh-invest/electricMeterBill/addBill', qs.stringify(data))
}
/**
 * 获取账单详情基本信息
 * @param {Object} data
 * @returns
 */
export function getElectricBillDetail (params) {
  return request.get('/ooh-invest/electricMeterBill/getBillDetail', { params })
}
/**
 * 从收款账单中移除电量记录明细
 * @param {Object} data
 * @returns
 */
export function removeFeeItemFromBill (data) {
  return request.post('/ooh-invest/electricMeterBill/removeFeeItemFromBill', qs.stringify(data))
}
/**
 * 添加电费明细项到收款账单中
 * @param {Object} data
 * @returns
 */
export function addFeeItemToBill (data) {
  return request.post('/ooh-invest/electricMeterBill/addFeeItemToBill', qs.stringify(data))
}
/**
 * 新增调整项差额
 * @param {Object} data
 * @returns
 */
export function addAdjustAmount (data) {
  return request.post('/ooh-invest/electricMeterBill/addAdjustAmount', qs.stringify(data))
}
/**
 * 提交收款账单
 * @param {Object} data
 * @returns
 */
export function submitBill (data) {
  return request.post('/ooh-invest/electricMeterBill/submitBill', qs.stringify(data))
}
/**
 * 根据账单id删除账单
 * @param {Object} data
 * @returns
 */
export function deleteByBillId (data) {
  return request.post('/ooh-invest/electricMeterBill/deleteByBillId', qs.stringify(data))
}
